import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { AnyConfigSchema, ConfigError, mapToMinimal, mapToStandard, minimalToMap, standardToMap } from '../types';
export var ParseError = /*#__PURE__*/function (_Error) {
  function ParseError(message, cause) {
    var _this;
    _classCallCheck(this, ParseError);
    _this = _callSuper(this, ParseError, [message]);
    _this.cause = cause;
    return _this;
  }
  _inherits(ParseError, _Error);
  return _createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function safeParse(json) {
  try {
    return {
      data: AnyConfigSchema.parse(JSON.parse(json)),
      success: true
    };
  } catch (error) {
    if (error instanceof Error) {
      return {
        success: false,
        error: error
      };
    }
    return {
      success: false,
      error: new ParseError('An unknown error occurred during parsing', error)
    };
  }
}
export var ConfigCollection = /*#__PURE__*/function () {
  function ConfigCollection(config) {
    _classCallCheck(this, ConfigCollection);
    this.config = config;
  }
  return _createClass(ConfigCollection, [{
    key: "toJson",
    value: function toJson(format) {
      switch (format) {
        case 'standard':
          return JSON.stringify(mapToStandard(this.config));
        case 'minimal':
          return JSON.stringify(mapToMinimal(this.config));
      }
    }
  }, {
    key: "getBoolean",
    value: function getBoolean(configName) {
      var config = this.config.get(configName);
      if (!config) {
        return {
          error: ConfigError.NotFound
        };
      }
      var value = config.value;
      if (typeof value !== 'boolean') {
        return {
          error: ConfigError.IncorrectType,
          received: value
        };
      }
      return {
        value: value
      };
    }
  }, {
    key: "getString",
    value: function getString(configName) {
      var config = this.config.get(configName);
      if (!config) {
        return {
          error: ConfigError.NotFound
        };
      }
      var value = config.value;
      if (typeof value !== 'string') {
        return {
          error: ConfigError.IncorrectType,
          received: value
        };
      }
      return {
        value: value
      };
    }
  }, {
    key: "getNumber",
    value: function getNumber(configName) {
      var config = this.config.get(configName);
      if (!config) {
        return {
          error: ConfigError.NotFound
        };
      }
      var value = config.value;
      if (typeof value !== 'number') {
        return {
          error: ConfigError.IncorrectType,
          received: value
        };
      }
      return {
        value: value
      };
    }
  }, {
    key: "getStringList",
    value: function getStringList(configName) {
      var config = this.config.get(configName);
      if (!config) {
        return {
          error: ConfigError.NotFound
        };
      }
      var value = config.value;
      if (!Array.isArray(value) || !value.every(function (x) {
        return typeof x === 'string';
      })) {
        return {
          error: ConfigError.IncorrectType,
          received: value
        };
      }
      return {
        value: value
      };
    }
  }, {
    key: "getNumberList",
    value: function getNumberList(configName) {
      var config = this.config.get(configName);
      if (!config) {
        return {
          error: ConfigError.NotFound
        };
      }
      var value = config.value;
      if (!Array.isArray(value) || !value.every(function (x) {
        return typeof x === 'number';
      })) {
        return {
          error: ConfigError.IncorrectType,
          received: value
        };
      }
      return {
        value: value
      };
    }
  }], [{
    key: "fromValues",
    value: function fromValues(values, options) {
      var result = safeParse(values);
      if (!result.success) {
        var parseError = new ParseError('Failed to deserialize config', result.error);
        if (options !== null && options !== void 0 && options.throw) {
          throw parseError;
        }

        // eslint-disable-next-line no-console
        console.error(parseError);
        return ConfigCollection.empty();
      }
      return new ConfigCollection(Array.isArray(result.data) ? minimalToMap(result.data) : standardToMap(result.data));
    }
  }, {
    key: "empty",
    value: function empty() {
      return new ConfigCollection(new Map());
    }
  }]);
}();